import React from 'react';
import { IonBadge } from '@ionic/react';
import { ChurchStatus } from '@/types/member';
import { CHURCH_STATUS_LABELS, CHURCH_STATUS_COLORS } from '@/utils/labels';

interface MemberStatusBadgeProps {
  status: ChurchStatus;
}

const MemberStatusBadge: React.FC<MemberStatusBadgeProps> = ({ status }) => {
  // "Activ" is the norm for every member, so the badge is just noise — only
  // surface exceptional statuses (transferat, decedat, exclus, sub disciplină).
  if (status === ChurchStatus.ACTIVE) return null;

  const label = CHURCH_STATUS_LABELS[status] ?? status;
  const color = CHURCH_STATUS_COLORS[status] ?? 'medium';

  return (
    <IonBadge
      color={color}
      style={{
        fontSize: '11px',
        padding: '4px 8px',
        borderRadius: '6px',
        fontWeight: 500,
      }}
    >
      {label}
    </IonBadge>
  );
};

export default MemberStatusBadge;
